import { TemplateStatus } from '../constants'

export function templateStatusLabel(id: number): 'active' | 'draft' | 'archived' | 'deleted' {
  const map: Record<number, 'active' | 'draft' | 'archived' | 'deleted'> = {
    [TemplateStatus.DRAFT]: 'draft', [TemplateStatus.ACTIVE]: 'active', [TemplateStatus.ARCHIVED]: 'archived', [TemplateStatus.DELETED]: 'deleted',
  }
  return map[id] ?? 'draft'
}
